import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ErrorValidatorService {

  private _errorData : any = {}

  constructor() { }

  setErrorData(data):void {
    this._errorData = data
  }

  get errorMessage():any{
   return this._errorData
  }

}
